const STATUS_TONES = {
  active: "success",
  completed: "success",
  inactive: "danger",
  pending: "warning",
  scheduled: "info",
  draft: "neutral",
  archived: "neutral",
};

/**
 * Maps a domain status (e.g. "Active", "pending") to a Badge tone.
 * Case-insensitive; unknown or empty statuses render neutral.
 * @param {string} status
 * @returns {"success"|"warning"|"danger"|"info"|"neutral"}
 */
export function statusTone(status) {
  if (typeof status !== "string") return "neutral";
  return STATUS_TONES[status.trim().toLowerCase()] || "neutral";
}

/**
 * Roles (Admin, Staff, Volunteer, …) are labels, not states: always neutral.
 * @returns {"neutral"}
 */
export function roleTone() {
  return "neutral";
}

export default statusTone;
